const PublicLayout = ({ children }) => {

    return (
        <div className="wrapper">{children}</div>
    )
}

export default PublicLayout